export type ExportableConsent = {
  gppString?: string | null;
  applicableSections?: number[] | null;
  tcfString?: string | null;
  gpc?: boolean | null;
  region?: 'eea-uk' | 'us' | 'us-ca' | 'row' | null;
  siteId?: string;
  subjectKey?: string;
  createdAt?: string; // ISO
};

export async function emitConsentToRegistry(opts: {
  baseUrl: string;
  bearer?: string;
  payload: ExportableConsent;
}): Promise<void> {
  const { baseUrl, bearer, payload } = opts;
  const url = new URL('/api/consent/v1/append', baseUrl);
  const res = await fetch(url.toString(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(bearer ? { Authorization: `Bearer ${bearer}` } : {}),
    },
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    // eslint-disable-next-line no-console
    console.warn('emitConsentToRegistry failed', res.status);
  }
}

export async function collectAndEmitConsent(opts: {
  baseUrl: string;
  bearer?: string;
  region: ExportableConsent['region'];
  gpc: boolean | null;
  siteId?: string;
  subjectKey?: string;
}): Promise<void> {
  const w = window as unknown as Record<string, unknown>;

  let gppString: string | null = null;
  let applicableSections: number[] | null = null;
  if (typeof (w['__gpp'] as unknown) === 'function') {
    await new Promise<void>((resolve) => {
      try {
        (w['__gpp'] as unknown as (cmd: string, cb: (data: unknown, ok: boolean) => void) => void)(
          'getGPPData',
          (data: unknown, ok: boolean) => {
            if (
              ok &&
              data &&
              typeof (data as Record<string, unknown>)?.['gppString'] === 'string'
            ) {
              const d = data as Record<string, unknown>;
              gppString = d['gppString'] as string;
              const secs = d['applicableSections'] as unknown;
              applicableSections = Array.isArray(secs) ? (secs as number[]) : null;
            }
            resolve();
          },
        );
      } catch {
        resolve();
      }
    });
  }

  let tcfString: string | null = null;
  if (typeof (w['__tcfapi'] as unknown) === 'function') {
    await new Promise<void>((resolve) => {
      try {
        (
          w['__tcfapi'] as unknown as (
            cmd: string,
            v: number,
            cb: (data: unknown, ok: boolean) => void,
          ) => void
        )('getTCData', 2, (data: unknown, ok: boolean) => {
          const ds = (data as Record<string, unknown>)?.['devCoreString'];
          if (ok && typeof ds === 'string') tcfString = ds as string;
          resolve();
        });
      } catch {
        resolve();
      }
    });
  }

  await emitConsentToRegistry({
    baseUrl: opts.baseUrl,
    bearer: opts.bearer,
    payload: {
      gppString,
      applicableSections,
      tcfString,
      gpc: opts.gpc,
      region: opts.region,
      siteId: opts.siteId,
      subjectKey: opts.subjectKey,
      createdAt: new Date().toISOString(),
    },
  });
}
